import { Card } from "react-bootstrap";

import React, { useEffect } from "react";
import { useAppConfig } from "@/appConfig";
import { isSyndicationCheckedByDefault } from "@/helpers/tenant";
import { trackEvent } from "@/services/analytics";
import GitchaSyndicationCard from "../../GitchaSyndicationCard";


const WantListingSyndication = ({
  handleFormValues,
  wantAdData,
}) => {
  const { flags } = useAppConfig();

  const showMLSFields = flags?.mlsAgentEditor;
  const syndicationDefault = isSyndicationCheckedByDefault();
  const track = (name, attributes) =>
    trackEvent({ name, attributes: { wantAdId: wantAdData?.wantAdId, ...attributes } });

  useEffect(() => {
    if (showMLSFields && wantAdData?.syndicateToThePublic === undefined) {
      handleFormValues({ syndicateToThePublic: syndicationDefault });
    }
  }, [showMLSFields, syndicationDefault, wantAdData?.syndicateToThePublic]);

  useEffect(() => {
    if (showMLSFields) {
      track("gitcha_syndication_toggle_viewed", { defaultOn: syndicationDefault });
    }
  }, [showMLSFields]);

  if (!showMLSFields) return null;

  return (
    <Card className="mb-4 border-0 bg-transparent want-listing-syndication">
      <Card.Body className="p-0">
        <GitchaSyndicationCard
          checked={wantAdData?.syndicateToThePublic ?? syndicationDefault}
          onChange={(e) => {
            handleFormValues({
              syndicateToThePublic: e.target.checked,
            });
            track("gitcha_syndication_toggled", { on: e.target.checked });
          }}
        />
      </Card.Body>
    </Card>
  );
};

export default WantListingSyndication;
